export default "__VITE_ASSET__CuxEp0RK__"